import { z } from 'zod';
import { validateRichTextContent } from '@shared/helpers';

export type VacancyEditMainInfoInitialValues = {
  activitySphereIds: Array<string>;
  ai_sphere_fill: boolean;
  name: string;
  companyId: string;
  cityIds: string[];
  interviewFinalMessage?: string | null;
  requiredCandidatesCount: string;
  scheduleWorkIds: Array<string>;
  employmentTypeIds: Array<string>;
  skills: Array<string>;
  currencyId: string;
  salaryFrom: number;
  salaryTo: number;
  paymentPeriodId: string;
  mandatoryRequirements: string;
  additionalRequirements: string;
  responsibilities: string;
  status: string;
  /** id выбранного тарифа (строка для Mantine Form) */
  tariffId: string;
};

// Zod схемы для валидации
export const VacancyEditMainInfoSchema = z
  .object({
    name: z.string().min(1, 'Название вакансии обязательно'),
    companyId: z.string().min(1, 'Выберите компанию'),
    cityIds: z.array(z.string()).min(1, 'Выберите хотя бы один город'),
    requiredCandidatesCount: z
      .string({ message: 'Выберите количество кандидатов' })
      .min(1, 'Выберите количество кандидатов'),
    interviewFinalMessage: z.string().optional().nullable(),
    activitySphereIds: z.array(z.string()).optional(),
    ai_sphere_fill: z.boolean(),
    scheduleWorkIds: z.array(z.string()).min(1, 'Выберите график работы'),
    employmentTypeIds: z
      .array(z.string())
      .min(1, 'Выберите хотя бы один тип занятости'),
    skills: z.array(z.string()).optional(),
    currencyId: z
      .string({ message: 'Выберите валюту' })
      .min(1, 'Выберите валюту'),
    salaryFrom: z
      .number({ message: 'Введите минимальную зарплату' })
      .min(1, 'Зарплата должна быть больше 0'),
    salaryTo: z
      .number({ message: 'Введите максимальную зарплату' })
      .min(1, 'Зарплата должна быть больше 0'),
    paymentPeriodId: z.string().min(1, 'Выберите период выплат'),
    mandatoryRequirements: z
      .string()
      .refine(value => validateRichTextContent(value), {
        message: 'Обязательные требования необходимы',
      }),
    additionalRequirements: z
      .string()
      .refine(value => validateRichTextContent(value), {
        message: 'Дополнительные требования необходимы',
      }),
    responsibilities: z
      .string()
      .refine(value => validateRichTextContent(value), {
        message: 'Обязанности необходимы',
      }),
    tariffId: z
      .string({ message: 'Выберите тариф' })
      .nonempty('Выберите тариф'),
  })
  .refine(data => data.salaryTo >= data.salaryFrom, {
    message: 'Максимальная зарплата должна быть больше или равна минимальной',
    path: ['salaryTo'],
  });
